var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex h-100 overflow-auto flex-column" },
    [
      _setup.formExists
        ? [
            _c(_setup.FormHeader, {
              attrs: { "form-id": _setup.formId, "show-save-btn": true },
            }),
            _vm._v(" "),
            _c(_setup.FormNavAndForm, {
              staticClass: "flex-grow-1",
              attrs: { "form-id": _setup.formId },
            }),
          ]
        : _c(
            "div",
            {
              staticClass:
                "flex-grow-1 d-flex align-items-center justify-content-center",
            },
            [
              _c("div", {
                staticClass: "spinner-border text-secondary",
                attrs: { role: "status" },
              }),
            ]
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }